// keyboard-shortcuts.js
// Gestion des raccourcis clavier et événements globaux

/**
 * Configure les raccourcis clavier
 */
export function setupKeyboardShortcuts(config) {
    const { recordButton, stopButton } = config;
  
    document.addEventListener('keydown', (event) => {
      // Empêcher les raccourcis si on est dans un input ou textarea
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
        return;
      }
  
      // R pour démarrer l'enregistrement
      if (event.code === 'Space') {
        if (!recordButton.disabled) {
          recordButton.click();
        }
      }
  
      // S pour arrêter l'enregistrement
      if (event.code === 'Space') {
        if (!stopButton.disabled) {
          stopButton.click();
        }
      }
  
      
    });
  }
  
  /**
   * Configure l'alerte avant fermeture de page
   */
  export function setupBeforeUnloadAlert() {
    window.addEventListener('beforeunload', (event) => {
      event.preventDefault();
      event.returnValue = '';
    });
  }